import { EZoneCategory } from '@watcherr/resources';
import { BarberIcon, BureauIcon, ElevatorIcon, StairsIcon, ToiletIcon } from './icons';

export const getCategory = (category: EZoneCategory) => categoriesConfig[category] ?? categoriesConfig.other;

const commonConfig = {
  icon: '\ue911',
  color: '#e0c45',
};

// Decide later if non-customized cats need a custom icon
const categoriesConfig: { [key in EZoneCategory]: any } = Object.values(EZoneCategory).reduce(
  (acc, cat) => {
    acc[cat] = commonConfig;
    return acc;
  },
  {} as { [key in EZoneCategory]: any }
);

categoriesConfig[EZoneCategory.Bedroom] = {
  icon: '\uE90F',
  color: '#6236ff',
};
categoriesConfig[EZoneCategory.Bathroom] = {
  icon: '\ue910',
  color: '#f716e0',
};
categoriesConfig[EZoneCategory.Kitchen] = {
  icon: '\ue90d',
  color: '#44d7b6',
};
categoriesConfig[EZoneCategory.Restaurant] = {
  icon: '\ue90d',
  color: '#44d7b6',
};
categoriesConfig[EZoneCategory.LivingRoom] = {
  icon: '\ue905',
  color: '#fa6400',
};
categoriesConfig[EZoneCategory.CommonRoom] = {
  icon: '\ue903',
  color: '#0091ff',
};
categoriesConfig[EZoneCategory.Hallway] = {
  icon: '\ue90e',
  color: '#56547c',
};
categoriesConfig[EZoneCategory.Outdoors] = {
  icon: '\ue906',
  color: '#6dd400',
};
categoriesConfig[EZoneCategory.PhysioTherapist] = {
  icon: '\ue900',
  color: '#F13C5C',
};
categoriesConfig[EZoneCategory.ExerciseArea] = {
  icon: '\ue900',
  color: '#F13C5C',
};
categoriesConfig[EZoneCategory.Other] = {
  icon: '\ue911',
  color: '#0e0c45',
};
categoriesConfig[EZoneCategory.Barber] = {
  color: '#BE7B00',
  Component: BarberIcon,
};
categoriesConfig[EZoneCategory.Basement] = {
  icon: '\ue911',
  color: '#0e0c45',
};
categoriesConfig[EZoneCategory.Elevator] = {
  icon: '\ue911',
  color: '#0e0c45',
  Component: ElevatorIcon,
};
categoriesConfig[EZoneCategory.Study] = {
  icon: '\ue911',
  color: '#1292DC',
  Component: BureauIcon,
};
categoriesConfig[EZoneCategory.Toilet] = {
  icon: '\ue911',
  color: '#f716e0',
  Component: ToiletIcon,
};
categoriesConfig[EZoneCategory.Staircase] = {
  icon: '\ue911',
  color: '#0e0c45',
  Component: StairsIcon,
};
categoriesConfig[EZoneCategory.Storage] = {
  icon: '\ue911',
  color: '#0e0c45',
};
categoriesConfig[EZoneCategory.Laundry] = {
  icon: '\ue911',
  color: '#0e0c45',
};
